import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { change as changeForm } from 'redux-form';
import PropTypes from 'prop-types';
import { SelectControl } from 'components/forms/Select';
import {
  VEHICLE_NAME,
  MODEL_NAME,
  SUB_TYPE_NAME,
} from 'components/searchAds/constants';

class ModelControl extends PureComponent {
  static propTypes = {
    changeForm: PropTypes.func.isRequired,
    formName: PropTypes.string,
    input: PropTypes.object,
    makeValue: PropTypes.string,
    options: PropTypes.array.isRequired,
    fieldIndex: PropTypes.number.isRequired,
  };

  handleChange = async (value) => {
    const { changeForm, formName, fieldIndex, input } = this.props;

    input.onChange(value);

    await changeForm(
      formName,
      `${VEHICLE_NAME}.${fieldIndex}.${SUB_TYPE_NAME}`,
      null,
    );
  };

  render() {
    const { makeValue, input, options } = this.props;

    return (
      <SelectControl
        {...this.props}
        qaSelector={MODEL_NAME}
        disabled={!options.length || !makeValue}
        input={{
          ...input,
          onChange: this.handleChange,
        }}
      />
    );
  }
}

export default connect(null, { changeForm })(ModelControl);
